import LogoText from "src/SharedComponents/LogoText/LogoText";
import { IDistributorInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { getChannelTypeIcon } from "src/Utils/Hooks/useGetDistributorInfo/SupportChannalTypes";
import { MailIcon, PhoneIcon, WhatsAppIcon, WeChatIcon, FacebookIcon, InstagramIcon, OtherChannelIcon } from "src/SharedComponents/Icons/Icons";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const channelIconMap: Record<string, React.ReactNode> = {
    WhatsApp: <WhatsAppIcon />,
    WeChat: <WeChatIcon />,
    Facebook: <FacebookIcon />,
    Instagram: <InstagramIcon />,
    Other: <OtherChannelIcon />,
};

interface IPartnerSupportInfoParams {
    partnerDetails: IDistributorInfo;
}
const PartnerSupportInfo : React.FC<IPartnerSupportInfoParams> = ({partnerDetails}) => {
    const { t } = useTranslation();

    var channalType = partnerDetails.supportContactDetail?.supportChannelType;
    var logoSrc = getChannelTypeIcon(channalType, "small");
    const channelIcon = channalType ? channelIconMap[channalType] : undefined;
    const show = useMemo(() => partnerDetails?.supportContactDetail?.contactNumber ||
    partnerDetails?.supportContactDetail?.email ||
    partnerDetails?.supportContactDetail?.supportChannelType ||
    partnerDetails?.supportContactDetail?.supportChannel,[partnerDetails?.supportContactDetail]);

    return (
    <>
    {show &&
     <>
          <div className="row">
                <div className="mb-2 col-9">
                    <span className="ds-subheader">{t('SupportContact')}</span>
                </div>
            </div>
            {partnerDetails?.supportContactDetail?.email && <LogoText logoElement={<MailIcon />} text={partnerDetails?.supportContactDetail?.email} />}
            {partnerDetails?.supportContactDetail?.contactNumber && <LogoText logoElement={<PhoneIcon />} text={partnerDetails?.supportContactDetail?.contactNumber} />}
            {partnerDetails?.supportContactDetail?.supportChannel && (
                channelIcon
                    ? <LogoText logoElement={channelIcon} text={partnerDetails?.supportContactDetail?.supportChannel} />
                    : <LogoText logoSrc={logoSrc} text={partnerDetails?.supportContactDetail?.supportChannel} />
            )}
     </>
    }
    </>)
}

export default PartnerSupportInfo;
